<template>
  <van-address-edit
    :area-list="areaList"
    :show-delete="!isNew"
    show-set-default
    :tel-validator="()=>{return true}"
    :area-columns-num="2"
    :area-columns-placeholder="[$t('common.selectTip'), $t('common.selectTip')]"
    :area-placeholder="$t('common.selectTip')"
    :address-info="companyInfo"
    @save="onSave"
    @delete="onDelete">
    <template #default="">
      <van-field v-model="tag" :label="$t('address.tag')" :placeholder="$t('common.fillTip')" />
    </template>
  </van-address-edit>
</template>

<script>
import { getAllCompany, deleteCompany, addCompany, amendCompany, setCompanyDefault } from '@/api/logistics'
import { getAllPeruAddress } from '@/api/peruAddress'
import i18n from '@/i18n'
import { Toast } from 'vant'

export default {
  data() {
    return {
      areaList: {},
      companyInfo: {},
      idNum: '',
      tag: '',
      isNew: true
    }
  },
  created() {
    this.areaList = getAllPeruAddress()
    if (this.$route.query.id) {
      this.isNew = false
      getAllCompany().then(res => {
        res.data.forEach(lc => {
          if (lc.id == this.$route.query.id) {
            const addressSplit = lc.receivingAddress.split(',')
            this.companyInfo = {
              id: lc.id,
              name: lc.name,
              tel: lc.phone,
              province: addressSplit[2],
              city: addressSplit[1],
              areaCode: '',
              addressDetail: addressSplit[0],
              isDefault: lc.isDefault
            }
            this.tag = lc.tag
            Object.keys(this.areaList.city_list).forEach(key => {
              if (this.areaList.city_list[key] == this.companyInfo.city) {
                this.companyInfo.areaCode = key
              }
            })
          }
        })
      })
    }
  },
  methods: {
    onSave(content) {
      // 服务端数据结构
      const companyData = {
        id: content.id,
        tag: this.tag,
        name: content.name,
        receivingAddress: content.addressDetail + ',' + content.city + ',' + content.province,
        phone: content.tel,
      }
      if (content.id > 0) {
        // 编辑
        amendCompany(companyData).then(res => {
          if (content.isDefault) {
            setCompanyDefault({ id: content.id }).then(defaultRes => {
              Toast.success(i18n.t('common.editSuccess'))
              this.$router.push('/logistics')
            })
          } else {
            Toast.success(i18n.t('common.editSuccess'))
            this.$router.push('/logistics')
          }
        })
      } else {
        // 新增
        addCompany(companyData).then(res => {
          Toast.success(i18n.t('common.addSuccess'))
          this.$router.push('/logistics')
        })
      }
    },
    onDelete() {
      deleteCompany({ id: this.companyInfo.id }).then(rep => {
        Toast.success(i18n.t('common.deleteSuccess'))
        this.$router.push('/logistics')
      })
    }
  }
}
</script>

<style>
.van-field__label {
  width: 4.3em;
}
</style>